// Configuración de URLs
export const APP_CONFIG = {
  // URL de la aplicación privada
  PRIVATE_APP_URL: process.env.NODE_ENV === 'production' 
    ? 'https://app.bluecmr.com'
    : 'http://localhost:3001',
  
  // URL de la web comercial
  PUBLIC_WEB_URL: process.env.NODE_ENV === 'production'
    ? 'https://bluecmr.com'
    : 'http://localhost:3000'
};

// Reservas de calendario y solicitud de demo visibles en la web pública.
// Apagado de sep-2026 a oct-2026 (pico de trabajo por la fecha límite del DeCA).
// Reabierto el 21-oct-2026: pasada la obligación legal, la web vuelve a ofrecer
// reservar demo, formulario y «que me llamen». Con `false`:
//   - /contacto/demo y /demo redirigen al formulario de contacto.
//   - La página de contacto no muestra la tarjeta «Reserva tu demo».
//   - Los CTA «Reservar demo» pasan a «Hablar con nosotros».
// /meeting y /booking/:token siguen funcionando: son enlaces que damos a mano.
// El agente de chat tiene su propio interruptor: PUBLIC_BOOKING_ENABLED en
// backend/functions/public-ai/shared/constants.mjs (variable de entorno).
export const PUBLIC_BOOKING_ENABLED = true;

// Canales de contacto que se muestran en la web (contacto, footer, asistente).
export const CONTACT = {
  phoneDisplay: '+34 987 191 362',
  phoneHref: 'tel:+34987191362',
  // Atención telefónica, hora de España.
  phoneHours: { es: 'Lunes a viernes, 08:30 – 15:00 h', en: 'Monday to Friday, 08:30 – 15:00 (CET)' },
  email: 'contact@bluecmr.com',
};
